var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("第三层")]),_c('p',[_vm._v("啊啦啦啦啦")]),_c('h4',[_vm._v("这是层2的数据----")]),_c('p',[_vm._v("id:"+_vm._s(_vm.id))])])
}
var staticRenderFns = []

export { render, staticRenderFns }